<!-- cookie-banner.component.html -->
<ng-container *ngIf="showBanner">
  <!-- Backdrop overlay -->
  <div class="cookie-overlay"></div>

  <!-- Banner -->
  <div class="cookie-banner" role="dialog" aria-modal="true" aria-label="Cookie consent">
    <div class="cookie-card">

      <!-- Header -->
      <div class="cookie-header">
        <div class="cookie-icon">🍪</div>
        <div class="cookie-title-group">
          <h3>Cookie Preferences</h3>
          <span>scripay.com</span>
        </div>
      </div>

      <!-- Body -->
      <div class="cookie-body">
        <p>
          We use cookies to enhance your browsing experience, analyze site traffic,
          and personalize content. By clicking <strong>Accept All</strong>, you consent
          to our use of cookies. You can manage your preferences below.
        </p>
      </div>

      <!-- Customize Panel -->
      <div class="cookie-toggles customize-panel" *ngIf="showCustomize">
        <div class="toggle-row">
          <div class="toggle-info">
            <span class="toggle-label">Essential</span>
            <span class="toggle-desc">Required for the site to function</span>
          </div>
          <label class="toggle-switch">
            <input type="checkbox" checked disabled />
            <span class="slider"></span>
          </label>
        </div>

        <div class="toggle-row">
          <div class="toggle-info">
            <span class="toggle-label">Analytics</span>
            <span class="toggle-desc">Help us understand how you use Scripay</span>
          </div>
          <label class="toggle-switch">
            <input type="checkbox" [(ngModel)]="consent.analytics" />
            <span class="slider"></span>
          </label>
        </div>

        <div class="toggle-row">
          <div class="toggle-info">
            <span class="toggle-label">Marketing</span>
            <span class="toggle-desc">Personalized offers and promotions</span>
          </div>
          <label class="toggle-switch">
            <input type="checkbox" [(ngModel)]="consent.marketing" />
            <span class="slider"></span>
          </label>
        </div>
      </div>

      <!-- Footer -->
      <div class="cookie-footer">
        <span class="cookie-meta">GDPR Compliant</span>
        <div class="cookie-actions">
          <button class="btn-reject" (click)="rejectAll()">Reject All</button>
          <button class="btn-customize" (click)="toggleCustomize()">
            {{ showCustomize ? 'Hide' : 'Customize' }}
          </button>
          <button class="btn-accept" (click)="showCustomize ? saveCustom() : acceptAll()">
            {{ showCustomize ? 'Save Preferences' : 'Accept All' }}
          </button>
        </div>
      </div>

    </div>
  </div>
</ng-container>